import { gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
const gtmReadMoreClick = (componentType, model, trim, bodyStyle, availabilityFlag) => {
    const gtmPayload = {
        event: 'cta_click',
        cta_type: 'click',
        link_text: 'disclaimer',
        cta_placement: 'footer',
        component_type: componentType,
        model,
        trim: removeAllTagsFromMarkdown(trim),
        body_style: bodyStyle,
        availability_flag: availabilityFlag,
    };
    const filteredPayload = Object.entries(gtmPayload).reduce((acc, [key, value]) => {
        if (value !== undefined && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {});
    gtmEvent(filteredPayload);
};
export default gtmReadMoreClick;
